import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, isRef as _isRef, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './../assets/EOSR0585-HDR-Edit(1).jpg'
import _imports_1 from './../assets/EOSR0578-HDR-Edit(1).jpg'
import _imports_2 from './../assets/6543-Exterior.jpg'
import _imports_3 from './../assets/view.png'
import _imports_4 from '../assets/button-download-icon.svg'
import _imports_5 from './../assets/plus-circle.svg'
import _imports_6 from './../assets/minus-circle.svg'
import _imports_7 from './../assets/sync-alt.svg'


const _hoisted_1 = { class: "site_plan" }
const _hoisted_2 = {
  key: 0,
  class: "leftPanel"
}
const _hoisted_3 = { class: "select_form" }
const _hoisted_4 = { class: "model_selection_header" }
const _hoisted_5 = { class: "radio_selection" }
const _hoisted_6 = { class: "pic_holder" }
const _hoisted_7 = { class: "pic_holder" }
const _hoisted_8 = { class: "pic_holder" }
const _hoisted_9 = { class: "pic_holder" }
const _hoisted_10 = { class: "midPanel" }
const _hoisted_11 = { id: "buttonSide" }
const _hoisted_12 = { class: "actionButton" }
const _hoisted_13 = { class: "actionButton" }
const _hoisted_14 = { class: "actionButton" }
const _hoisted_15 = {
  key: 1,
  class: "bottomPanel"
}
const _hoisted_16 = { class: "select_form" }
const _hoisted_17 = { class: "model_selection_header" }
const _hoisted_18 = { class: "radio_selection" }
const _hoisted_19 = { class: "pic_holder" }
const _hoisted_20 = { class: "pic_holder" }
const _hoisted_21 = { class: "pic_holder" }
const _hoisted_22 = { class: "pic_holder" }
const _hoisted_23 = { class: "lotName" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 1,
  class: "modalInfotext"
}
const _hoisted_26 = ["href"]

import axios from "axios";
import { onMounted, ref, watch } from "vue";
import Panzoom from "@panzoom/panzoom";
import { appStore } from "@/stores/app-store";
import { BuildingData } from "@/stores/app-state";
import UnitModal from '@/components/UnitModal.vue';
import FilterModal from '@/components/FilterModal.vue';
import LoadingModal from '@/components/LoadingModal.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SitePlanComponent',
  setup(__props) {

const store = appStore();

const svgDiv = ref();
const exterior6543 = ref();
const exterior6601 = ref();
const exterior6603 = ref();

const showUnitModal = ref(false);
const showEmbedForm = ref(false);
const showFilterModal = ref(false);
const selectedLotId = ref('');
const modalTitleText = ref();
const lotPriceText = ref();
const lotBedroomsText = ref();
const lotBathroomsText = ref();
const lotSizeText = ref();
const lotParkingSpaceText = ref();
const lotFloorplanName = ref('');
const lotUnitInfoText = ref();
const floorplanURL = ref('');
const linkText = ref('');
const linkURL = ref('');

const showLoadingModal = ref(false);

const zoomInRef = ref();
const zoomOutRef = ref();
const zoomResetRef = ref();
const siteplanImgContainer = ref();
const controlRightOffest = ref('15px');

const berylPrice = ref("From low $1Ms");
const citrinePrice = ref("From $1,259,000");
const lapisPrice = ref("From $1,599,000");

let unitsAvailable = ref(0);
let currentFloorplanIndex = ref(0);

let panning = false;
let panzoom: any;

let floorplan = ref(store.floorplanFilter);
let status = ref(store.statusFilter);

const isWideScreen = ref(true);

let theModelMarkerElement: any;

watch(showUnitModal, (newShow, oldShow) => {
  if (newShow) {
    document.body.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
  }
});

onMounted(() => {
  var svgHtml = document.querySelector('#svgImage');
  axios.get("SadleSquare_SitePlan.svg").
    then((data: any) => {
      store.siteSVG = data.data;
      svgDiv.value.innerHTML = store.siteSVG;
      initPanzoom();
      axios.get("https://homedesigner.truevistavr.com/siteplanAPI/siteplan/SadlerSquare")
        .then((data: any) => {
          store.unitsData = data.data;
          iterateSVG();

          //Setting right pan location after svg loaded etc
          setTimeout(() => {
            panzoom.reset();
          }, 50);
        });
    });
  window.addEventListener("resize", windowResizeChange);
  windowResizeChange();
});

const windowResizeChange = () => {
  if (siteplanImgContainer.value.clientWidth > siteplanImgContainer.value.clientHeight) {
    controlRightOffest.value =
      ((siteplanImgContainer.value.clientWidth - siteplanImgContainer.value.clientHeight) / 2) + 15 + "px";
  } else {
    controlRightOffest.value = "15px";
  }
  isWideScreen.value = window.innerWidth >= 1024;// || (window.matchMedia("(orientation: landscape)").matches);
};

function filterModelChange(newFilter: string) {
  if (floorplan.value == newFilter) {
    floorplan.value = "";
  } else {
    floorplan.value = newFilter;
  }
  console.log("Filter changed");
  store.floorplanFilter = floorplan.value;
  iterateSVG();
}

function filterStatusChange() {
  store.statusFilter = status.value != "All" ? status.value : "";
  if (status.value == "All") {
    status.value = "";
  }
  iterateSVG();
}


function iterateSVG() {
  var svgHtml = document.querySelector('#svgImage');
  //svgHtml!.innerHTML = store.siteSVG;
  unitsAvailable.value = 0;

  let svg = svgDiv.value.children[0];
  svg.querySelectorAll('circle').forEach((element: any) => {
    let elementClass = element.getAttribute('class');
    if (elementClass == "tempCircle") {
      element.remove();
    }

  });

  svg.querySelectorAll('use').forEach(element => {
    let elementID = element.getAttribute('id');

    if (elementID == null)
      return;
    if (elementID == "ModelMarker") {
      theModelMarkerElement = element;
      //theModelMarkerElement!.setAttribute('visibility', 'visible');
      console.log(elementID);
    }
  });

  svg.querySelectorAll('g').forEach((element: any) => {
    let elementID = element.getAttribute('id');

    if (elementID == null)
      return;

    // if(elementID == "ModelMarker"){
    //   theModelMarkerElement = element;
    //   theModelMarkerElement!.setAttribute('visibility', 'hidden');
    //   console.log(elementID);
    // }
    elementID = elementID.substring(1);
    let findEl = store.unitsData.find((obj: any) => { return obj.unitId === elementID });
    let rectElem = element.querySelector('rect');

    if (rectElem == null) rectElem = element.querySelector('path');

    let futurePhase = false;
    if (store.floorplanFilter == '' && store.statusFilter == '')
      store.futurePhaseBuildings.forEach((building: BuildingData) => {
        if (!building.enabled) return;
        if (elementID >= building.startUnit && elementID <= building.endUnit) {
          // element.visibility = 'hidden';
          // element.setAttribute('visibility', 'hidden');
          futurePhase = false;
          return;
        }
      });

    if (findEl == null || rectElem == null)
      return;

    let triangleElem: any;
    let allPaths = element.querySelectorAll('path');
    if (allPaths.length == 2) {
      triangleElem = allPaths[1];
    } else if (allPaths.length == 1 && allPaths[0] != rectElem) {
      triangleElem = allPaths[0];
    }

    if (triangleElem != null) {
      triangleElem.style = "fill:white;pointer-events: none;";
    }

    rectElem.onclick = () => {
      if (panning) return;
      if (findEl!.status == "AFF" || findEl!.floorPlanName == "Amber") return;
      lotFloorplanName.value = findEl!.floorPlanName;
      selectedLotId.value = findEl!.unitName;
      modalTitleText.value = "Homesite " + findEl!.unitName;
      // lotPriceText.value = findEl!.status == "Available"?
      // `$${(findEl!.startingPrice*1000).toLocaleString("EN-US")}`: "";
      // if(findEl!.status == "ComingSoon") lotPriceText.value = "Coming Soon";
      // lotBedroomsText.value = `Bedrooms: ${findEl!.minBedrooms} - ${findEl!.maxBedrooms}`;
      // lotBathroomsText.value = `Baths: ${findEl!.minBathrooms} - ${findEl!.maxBathrooms}`;
      // lotSizeText.value = `Size: ${findEl!.minSqft.toLocaleString()} - ${findEl!.maxSqft.toLocaleString()} sq. ft.`;
      // lotParkingSpaceText.value = `Parking Space: ${findEl!.parkingSpace}-Car Garage`;
      lotUnitInfoText.value = findEl!.infoText;
      showUnitModal.value = true;
      if (findEl!.linkURL) {
        try {
          let testUrl = new URL(findEl!.linkURL);
        } catch (err) {
          console.log('invalid URL');
          linkURL.value = '';
        }

        linkURL.value = findEl!.linkURL;
        linkText.value = findEl!.linkText.length > 0 ? findEl!.linkText : linkURL.value;
      } else {
        linkURL.value = "";
      }

      switch (findEl!.unitId) {
        case '6601':
          floorplanURL.value = 'https://www.millerandsmith.com/immediate-delivery/delano';
          lotUnitInfoText.value = "- 3 Bedrooms, 3 Full Baths, 1 Half Bath\n- 2 Car Garage, 4300 Sq. Ft.\n- $1,073,554";
          break;
        case '6543': floorplanURL.value = 'https://www.millerandsmith.com/immediate-delivery/delano-2';
          lotUnitInfoText.value = "- 4 Bedrooms, 3 Full Baths, 1 Half Bath\n- 2 Car Garage\n- 4300 Sq. Ft.\n- $1,140,514";
          break;
        case '6603': floorplanURL.value = 'https://www.millerandsmith.com/immediate-delivery/delano-3';
          lotUnitInfoText.value = "- 3 Bedrooms, 3 Full Baths, 1 Half Bath\n- 2 Car Garage\n- 4300 Sq. Ft.\n- $1,103,524";
          break;
        default:
          floorplanURL.value = '';
      }

      currentFloorplanIndex.value = getFloorplanIndexFromName(findEl!.floorPlanName);
      if (triangleElem != null && findEl!.floorPlanName == "Citrine") {
        currentFloorplanIndex.value = 3;
      }
    };
    // let textElem = element.querySelector('text');

    // let prevTextStyle = textElem.getAttribute('style');
    // textElem.style = 'cursor: default;pointer-events: none; fill:none';


    let textColor = "fill:white;";

    rectElem.style = getFloorplanStyle(findEl!.floorPlanName, futurePhase ? "ComingSoon" : findEl!.status);

    let boundingBox = element.getBBox();
    //console.log(element.getBBox());
    let x = boundingBox.x;//rectElem.x.baseVal.value;
    let y = boundingBox.y;//rectElem.y.baseVal.value;
    let width = boundingBox.width;//rectElem.width.baseVal.value;
    let height = boundingBox.height;//rectElem.height.baseVal.value;
    let xOffset = elementID < 7 || elementID > 66 ? 4 : 4;
    let yOffset = elementID < 7 || elementID > 66 ? 0 : -3;

    if ((findEl.status == "Unavailable" || futurePhase || findEl.status == "AFF" || findEl.floorPlanName == "Amber")
      && store.statusFilter != 'ComingSoon') {
      textColor = "fill:none;"
      //rectElem.onclick = () => {return false};
    }

    let cplace = element.querySelector('circle');
    if (cplace) {
      cplace.style = 'cursor: default;pointer-events: none;fill:none;';
    }

    let floorplanCheck = store.floorplanFilter != '' && store.floorplanFilter != findEl?.floorPlanName;
    let statusCheck = store.statusFilter != '' && store.statusFilter != findEl.status;

    if (store.statusFilter == "Available") {
      statusCheck = findEl.status != "Available" && findEl.status != "SpecHome";
    }

    if ((floorplanCheck || statusCheck) && !futurePhase) {
      textColor = "fill:none;"

      if (findEl.status == "AFF" || findEl.floorPlanName == "Amber") {
        textColor = "fill:none;"
      }

      if (triangleElem != null) {
        triangleElem.style = "fill:grey;pointer-events: none;";
      }

      rectElem.style = 'fill:#00000096;cursor: default;';
    } else if (findEl.status == "Sold" && !futurePhase) {
      addSoldCircle();
    } else if (findEl.status == "Model" && !futurePhase) {
      addModelCircle();
    } else if (findEl.status == "Available" && !futurePhase) {
      unitsAvailable.value++;
    }

    //textElem.style = prevTextStyle+=';cursor: default;pointer-events: none;'+textColor;

    function addModelCircle() {
      let cx = x + width / 2 - 4 + xOffset;
      let cy = y + height / 2 + 3 + yOffset;
      let textX = x + width / 2 - 13.5 + xOffset;
      let textY = y + height / 2 + 6 + yOffset;
      if (cplace != null) {
        cx = cplace.cx.baseVal.value;
        cy = cplace.cy.baseVal.value;
        textX = cx - 13.5;
        textY = cy + 4.5;
      }
      var circle2 = makeSVG('circle', { class: "tempCircle", cx: cx, cy: cy, r: 36, stroke: '#131E29', 'stroke-width': 4, fill: 'White', style: "default;pointer-events: none;" });
      // var text2=makeSVG('text', { x: textX, y: textY, style: "font-family: 'DIN-Condensed'; font-weight:700;font-size:13px;fill:#00599E; default;pointer-events: none;" });
      // text2.textContent="MODEL";
      element.appendChild(circle2);
      // element.appendChild(text2);
    }

    function addSoldCircle() {
      let cx = x + width / 2 - 4 + xOffset;
      let cy = y + height / 2 + 3 + yOffset;
      let textX = x + width / 2 - 13 + xOffset;
      let textY = y + height / 2 + 6.5 + yOffset;
      if (cplace != null) {
        cx = cplace.cx.baseVal.value;
        cy = cplace.cy.baseVal.value;
        textX = cx - 25;
        textY = cy + 10;
      }
      var circle = makeSVG('circle', { class: "tempCircle", cx: cx, cy: cy, r: 30, stroke: 'white', 'stroke-width': 1.5, fill: '#F60808', style: "default;pointer-events: none;" });
      //var text=makeSVG('text', { x: textX, y: textY, style: "font-family: 'D-DIN Condensed'; font-weight:400;font-size:30px;fill:white; default;pointer-events: none;" });
      //text.textContent="SOLD";
      element.appendChild(circle);
      //element.appendChild(text);
    }
  });
}


function initPanzoom() {
  var element = document.querySelector('#svgImage');
  // let startX = element.offsetWidth * -0.17//-125;
  // let startY = element.offsetHeight * -0.05;//-25;
  // let startScale = 2.25;
  // if(!isWideScreen.value){
  //   startX = element.offsetWidth * -0.16;
  //   startY = element.offsetHeight * -0.1;
  //   startScale = 2.4;
  // }

  panzoom = Panzoom(element, {
    maxScale: 6,
    minScale: 1,
    // startScale: 1.23,
    // startY: startY,
    // startX: startX,
    animate: true,
    duration: 100,
    cursor: 'default',
    contain: "outside"
  });
  element!.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

  var timeout: any;
  element.addEventListener('panzoomchange', function (event) {
    panning = true;
    // if(event.detail.scale > 1.5){
    //   theBarnLogoElement!.setAttribute('visibility', 'hidden');
    // }else{
    //   theBarnLogoElement!.setAttribute('visibility', 'visible');
    // }
    window.clearTimeout(timeout);
    timeout = setTimeout(() => {
      panning = false;
    }, 100);
  });

  zoomInRef.value.onclick = () => { panzoom.zoomIn(); };
  zoomOutRef.value.onclick = () => { panzoom.zoomOut(); };
  zoomResetRef.value.onclick = () => {
    panzoom.reset();
    store.floorplanFilter = '';
    store.statusFilter = '';
    iterateSVG();
    filterModelChange('');
  };
}

function getFloorplanStyle(floorPlanName: string, lotStatus: string) {
  let default_cursor = "default"

  return `fill:#00000000;cursor: ${default_cursor};`;
}



function makeSVG(tag: string, attrs: any) {
  var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
  for (var k in attrs)
    el.setAttribute(k, attrs[k]);
  return el;
}
function getFloorplanIndexFromName(floorplanName: string) {
  switch (floorplanName) {
    case 'Amber':
      return 0;
    case 'Beryl':
      return 1;
    case 'Citrine':
      return 2;
    case 'Lapis':
      return 4;
    default:
      return 0;
  }
}
function getFilterInfoText() {
  switch (store.floorplanFilter) {
    case 'The Bellair':
      return `SHOWING BELLAIR (${unitsAvailable.value} UNITS AVAILABLE)`;
    case 'The Cessna':
      return `SHOWING CESSNA (${unitsAvailable.value} UNITS AVAILABLE)`;
    case 'The Douglas':
      return `SHOWING DOUGLAS (${unitsAvailable.value} UNITS AVAILABLE)`;
    default:
      return ``;
  }
}

function statusToText(status: string) {
  switch (status) {
    case "ComingSoon":
      return "Coming Soon"
    default:
      return status;
  }
}

// function getFloorplanURL(){
//   switch (currentFloorplanIndex.value) {
//         case 0:
//             return "";
//         case 1:
//             return "https://www.eya.com/townhomes/bethesda-md/westbard-square/homes-floorplans/beryl-model";
//         case 2:
//             return "https://www.eya.com/townhomes/bethesda-md/westbard-square/homes-floorplans/citrine-model";
//         case 3:
//             return "https://www.eya.com/townhomes/bethesda-md/westbard-square/homes-floorplans/citrine-with-elevator-model";
//         case 4:
//           return "https://www.eya.com/townhomes/bethesda-md/westbard-square/homes-floorplans/lapis-model";
//         default:
//             return "";
//     }
// }

function getImageURL(): string {
  switch (selectedLotId.value) {
    case '6601':
      return exterior6601.value.src;
    case '6603':
      return exterior6603.value.src;
    case '6543':
      return exterior6543.value.src;
    default:
      return '';
  }
}

async function downloadSitePlan() {

  // let test = 1;
  // if(test == 1) return;
  store.statusFilter = "";
  store.floorplanFilter = "";
  iterateSVG();

  const svg = document.querySelector('svg');
  if (svg) {
    showLoadingModal.value = true;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    let widthFormatOk = svg.width.baseVal.value.toString() == svg.width.baseVal.valueAsString;
    let heightFormatOk = svg.width.baseVal.value.toString() == svg.height.baseVal.valueAsString;
    let defaultWidth = '';
    let defaultHeight = '';
    if (!widthFormatOk || !heightFormatOk) {
      let viewBox = svg.viewBox.baseVal;
      if (viewBox) {
        defaultWidth = svg.width.baseVal.valueAsString;
        defaultHeight = svg.height.baseVal.valueAsString;
        //iOS canvas limit is 4096x4096 pixels, if this doesn't help, check if backgroudn image ID is set simply to "background" not some name with spaces and symbols.
        let scaleRatio = 4096 / viewBox.width;

        svg.setAttribute("width", (4096).toString());
        svg.setAttribute("height", (Math.floor(viewBox.height * scaleRatio)).toString());
        canvas.width = 4096;
        canvas.height = Math.floor(viewBox.height * scaleRatio);
        console.log(canvas.width, canvas.height);
      }
    }
    // theModelMarkerElement!.setAttribute('visibility', 'visible');

    const xml = new XMLSerializer().serializeToString(svg);
    const img = new Image();
    img.src = 'data:image/svg+xml;base64,' + btoa(xml);

    img.onload = async function () {
      ctx!.fillStyle = "white";
      ctx!.fillRect(0, 0, canvas.width, canvas.height);

      ctx!.drawImage(img, 0, 0);
      // theModelMarkerElement!.setAttribute('visibility', 'hidden');
      panzoom.reset();

      const dataURL = canvas.toDataURL("image/jpeg", 0.8);
      svg.setAttribute("width", defaultWidth);
      svg.setAttribute("height", defaultHeight);
      iterateSVG();
      // put file into form data
      var formdata = new FormData();
      formdata.append("siteplanImg", dataURL);
      console.error("Siteplan size:" + dataURL.length)
      const response = await fetch('https://homedesigner.truevistavr.com/fileAPI/siteplan/sadlersquare', {
        method: "POST",
        //TODO add some floorplan identifier number so know which page to use
        body: formdata
      })
        .then(res => {
          if (res.ok) {
            return res.blob()
          }
          throw new Error('Error occured')
        })
        .then(data => {
          console.log(data)
          var a = document.createElement("a")
          a.href = window.URL.createObjectURL(data)
          a.download = "Miller & Smith Sadler Square - Siteplan.pdf"
          a.click()
          showLoadingModal.value = false
        })
        .catch((error) => {
          console.log(error)
          showLoadingModal.value = false
        })
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      ref_key: "exterior6601",
      ref: exterior6601,
      src: _imports_0,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "exterior6603",
      ref: exterior6603,
      src: _imports_1,
      hidden: ""
    }, null, 512),
    _createElementVNode("img", {
      ref_key: "exterior6543",
      ref: exterior6543,
      src: _imports_2,
      hidden: ""
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "select_label" }, "Select Model", -1)),
                _createElementVNode("label", {
                  class: "select_label show_all",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {{ _isRef(floorplan) //@ts-ignore
 ? floorplan.value = '' : floorplan = ''; filterModelChange('') }})
                }, "Show All")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Maison' }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (filterModelChange('Maison')))
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "square maison" }, null, -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Maison")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_6, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Maison']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Everly' }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (filterModelChange('Everly')))
                }, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "square everly" }, null, -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Everly")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_7, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Everly']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Arden' }),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (filterModelChange('Arden')))
                }, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "square arden" }, null, -1)),
                  _cache[24] || (_cache[24] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Arden")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_8, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Arden']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Crosby' }),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (filterModelChange('Crosby')))
                }, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "square crosby" }, null, -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Crosby")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Crosby']
                  ])
                ], 2)
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "select_label" }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                onChange: filterStatusChange
              }, [...(_cache[28] || (_cache[28] = [
                _createStaticVNode("<option value=\"\" selected data-v-68a58d15>All</option><option value=\"Available\" data-v-68a58d15>Available</option><option value=\"SpecHome\" data-v-68a58d15>Spec Home</option><option value=\"ComingSoon\" data-v-68a58d15>Coming Soon</option><option value=\"Sold\" data-v-68a58d15>Sold</option>", 5)
              ]))], 544), [
                [_vModelSelect, _unref(status)]
              ])
            ]),
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "statusLegend" }, [
              _createElementVNode("div", { class: "legendItem" }, [
                _createElementVNode("div", { class: "soldCircle" }),
                _createTextVNode("Sold ")
              ])
            ], -1)),
            _createElementVNode("button", {
              class: "downloadButton",
              onClick: downloadSitePlan
            }, [...(_cache[30] || (_cache[30] = [
              _createElementVNode("img", { src: _imports_4 }, null, -1),
              _createTextVNode("DOWNLOAD SITE PLAN", -1)
            ]))])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          id: "siteplanImage",
          ref_key: "siteplanImgContainer",
          ref: siteplanImgContainer
        }, [
          _createElementVNode("div", {
            ref_key: "svgDiv",
            ref: svgDiv,
            id: "svgImage"
          }, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("div", { class: "loaderContainer" }, [
              _createElementVNode("div", { class: "loader" })
            ], -1)
          ]))], 512)
        ], 512),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", _hoisted_12, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomInRef",
              ref: zoomInRef,
              src: _imports_5
            }, null, 512)
          ]),
          _createElementVNode("button", _hoisted_13, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomOutRef",
              ref: zoomOutRef,
              src: _imports_6
            }, null, 512)
          ]),
          _createElementVNode("button", _hoisted_14, [
            _createElementVNode("img", {
              class: "legendButtonImg",
              ref_key: "zoomResetRef",
              ref: zoomResetRef,
              src: _imports_7
            }, null, 512)
          ])
        ])
      ]),
      (!isWideScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "select_label" }, "Select Model", -1)),
                _createElementVNode("label", {
                  class: "select_label show_all",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {{ _isRef(floorplan) //@ts-ignore
 ? floorplan.value = '' : floorplan = ''; filterModelChange('') }})
                }, "Show All")
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Maison' }),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (filterModelChange('Maison')))
                }, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "square maison" }, null, -1)),
                  _cache[36] || (_cache[36] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Maison")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_19, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Maison']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Everly' }),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (filterModelChange('Everly')))
                }, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "square everly" }, null, -1)),
                  _cache[39] || (_cache[39] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Everly")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_20, [...(_cache[37] || (_cache[37] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Everly']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Arden' }),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (filterModelChange('Arden')))
                }, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "square arden" }, null, -1)),
                  _cache[42] || (_cache[42] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Arden")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_21, [...(_cache[40] || (_cache[40] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Arden']
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass({ active_model: _unref(floorplan) == 'Crosby' }),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (filterModelChange('Crosby')))
                }, [
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "square crosby" }, null, -1)),
                  _cache[45] || (_cache[45] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "model_title" }, "Crosby")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_22, [...(_cache[43] || (_cache[43] = [
                    _createElementVNode("img", {
                      class: "eye_img",
                      src: _imports_3
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, _unref(floorplan) == 'Crosby']
                  ])
                ], 2)
              ]),
              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "select_label" }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "mobile",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                onChange: filterStatusChange
              }, [...(_cache[46] || (_cache[46] = [
                _createStaticVNode("<option value=\"\" selected data-v-68a58d15>All</option><option value=\"Available\" data-v-68a58d15>Available</option><option value=\"SpecHome\" data-v-68a58d15>Spec Home</option><option value=\"ComingSoon\" data-v-68a58d15>Coming Soon</option><option value=\"Sold\" data-v-68a58d15>Sold</option>", 5)
              ]))], 544), [
                [_vModelSelect, _unref(status)]
              ])
            ]),
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "statusLegend" }, [
              _createElementVNode("div", { class: "legendItem" }, [
                _createElementVNode("div", { class: "soldCircle" }),
                _createTextVNode("Sold ")
              ])
            ], -1)),
            _createElementVNode("button", {
              class: "mobilDownloadButton",
              onClick: downloadSitePlan
            }, [...(_cache[48] || (_cache[48] = [
              _createElementVNode("img", { src: _imports_4 }, null, -1),
              _createTextVNode("DOWNLOAD SITE PLAN", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(UnitModal, {
        isWideScreen: isWideScreen.value,
        show: showUnitModal.value,
        showForm: showEmbedForm.value,
        lotId: selectedLotId.value,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (showUnitModal.value = false, showEmbedForm.value = false))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, _toDisplayString(modalTitleText.value), 1)
        ]),
        body: _withCtx(() => [
          _cache[50] || (_cache[50] = _createElementVNode("div", null, null, -1)),
          (floorplanURL.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: getImageURL(),
                class: "modalImagePreview"
              }, null, 8, _hoisted_24))
            : _createCommentVNode("", true),
          (lotUnitInfoText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(lotUnitInfoText.value), 1))
            : _createCommentVNode("", true),
          (linkURL.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                target: "_blank",
                class: "modalLink",
                href: linkURL.value
              }, _toDisplayString(linkText.value), 9, _hoisted_26))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "formButton",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (showEmbedForm.value = true))
          }, "Contact Me About This Home")
        ]),
        _: 1
      }, 8, ["isWideScreen", "show", "showForm", "lotId"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(FilterModal, {
        show: showFilterModal.value,
        onClose: _cache[14] || (_cache[14] = ($event: any) => (showFilterModal.value = false)),
        onFilter: iterateSVG,
        testWidth: 200
      }, {
        header: _withCtx(() => [...(_cache[51] || (_cache[51] = []))]),
        body: _withCtx(() => [...(_cache[52] || (_cache[52] = []))]),
        _: 1
      }, 8, ["show"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(LoadingModal, { show: showLoadingModal.value }, null, 8, ["show"])
    ]))
  ], 64))
}
}

})